import { FC } from 'react';
import { ITooltip, Tooltip as ReactTooltip } from 'react-tooltip';

export const Tooltip: FC<ITooltip> = ({ place, delayShow = 200, offset }) => {
  return (
    <ReactTooltip
      place={place}
      delayShow={delayShow}
      offset={offset}
    />
  );
};
